const DNI_REGEX = /^[0-9]{8}[A-Z]$/i;
const NIE_REGEX = /^[XYZ][0-9]{7}[A-Z]$/i;
// Near-miss: 6–10 digits (±2) ending in a letter, or NIE prefix with 5–9 digits ending in a letter
const DNI_NEAR_REGEX = /^[0-9]{6,10}[A-Z]$/i;
const NIE_NEAR_REGEX = /^[XYZ][0-9]{5,9}[A-Z]$/i;
const CONTROL_LETTERS = 'TRWAGMYFPDXBNJZSQVHLCKE';

const nieFirstDigit = { X: '0', Y: '1', Z: '2' };

/**
 * Soft DNI/NIE validation.
 * - Exact format (8 digits + letter / X|Y|Z + 7 digits + letter): validates control letter.
 * - Near-miss format (±2 digits): warns about likely typo in digit count.
 * - Anything else: no error (passport, CIF, etc.).
 */
export const validateDniSoft = (value) => {
  if (!value) return null;

  const upper = value.trim().toUpperCase();

  if (DNI_REGEX.test(upper)) {
    const num = parseInt(upper.slice(0, 8), 10);
    const expected = CONTROL_LETTERS[num % 23];
    if (upper[8] !== expected) {
      return `La letra del DNI no es correcta (debería ser ${expected}).`;
    }
    return null;
  }

  if (NIE_REGEX.test(upper)) {
    const digits = nieFirstDigit[upper[0]] + upper.slice(1, 8);
    const num = parseInt(digits, 10);
    const expected = CONTROL_LETTERS[num % 23];
    if (upper[8] !== expected) {
      return `La letra del NIE no es correcta (debería ser ${expected}).`;
    }
    return null;
  }

  // Near-miss checks (only reached if exact format didn't match)
  if (DNI_NEAR_REGEX.test(upper)) {
    const digits = upper.slice(0, -1);
    const diff = digits.length - 8;
    const hint = diff > 0 ? `Sobra${diff > 1 ? 'n' : ''} ${diff} dígito${diff > 1 ? 's' : ''}` : `Falta${Math.abs(diff) > 1 ? 'n' : ''} ${Math.abs(diff)} dígito${Math.abs(diff) > 1 ? 's' : ''}`;
    return `Parece un DNI pero no tiene el formato correcto. ${hint} (un DNI español tiene 8 dígitos y una letra).`;
  }

  if (NIE_NEAR_REGEX.test(upper)) {
    const digits = upper.slice(1, -1);
    const diff = digits.length - 7;
    const hint = diff > 0 ? `Sobra${diff > 1 ? 'n' : ''} ${diff} dígito${diff > 1 ? 's' : ''}` : `Falta${Math.abs(diff) > 1 ? 'n' : ''} ${Math.abs(diff)} dígito${Math.abs(diff) > 1 ? 's' : ''}`;
    return `Parece un NIE pero no tiene el formato correcto. ${hint} (un NIE español tiene X/Y/Z, 7 dígitos y una letra).`;
  }

  return null;
};
